
import { defineComponent, PropType } from 'vue';
import {
  CaiDatLoaiGiaTri,
  ICaiDatTuyChon,
} from '@/core/interfaces/ApiResponses';

export default defineComponent({
  name: 'cai-dat-gia-tri-control',

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    loaiGiaTri: {
      type: String as PropType<CaiDatLoaiGiaTri>,
      default: 'text',
    },
    tuyChon: {
      type: Array as PropType<ICaiDatTuyChon[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue'],

  setup(_props, { emit }) {
    const emitValue = (value: string | number | null | undefined) => {
      emit('update:modelValue', value == null ? '' : String(value));
    };

    return { emitValue };
  },
});
